import script from "./TRListe.vue?vue&type=script&setup=true&lang=ts"
export * from "./TRListe.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__